export default __webpack_public_path__ + "static/media/casual-mini.18688f30.jpg";